function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.08328e-06 26.4117C1.15482 27.5665 2.52578 28.4826 4.03461 29.1076C5.54344 29.7325 7.1606 30.0542 8.79375 30.0542C10.4269 30.0542 12.0441 29.7325 13.5529 29.1075C15.0617 28.4826 16.4327 27.5665 17.5875 26.4117C18.7423 25.2569 19.6583 23.8859 20.2833 22.3771C20.9083 20.8683 21.23 19.2511 21.23 17.618C21.23 15.9848 20.9083 14.3677 20.2833 12.8588C19.6583 11.35 18.7423 9.97903 17.5875 8.82422L8.79375 17.618L5.08328e-06 26.4117Z",
  fill: "url(#sureLogoGradient)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.769 3.64249C21.6142 2.48768 20.2433 1.57163 18.7344 0.946651C17.2256 0.321672 15.6084 -2.72555e-07 13.9753 0C12.3421 2.72555e-07 10.725 0.321673 9.21615 0.946653C7.70732 1.57163 6.33636 2.48768 5.18155 3.64249C4.02674 4.7973 3.11069 6.16826 2.48571 7.67709C1.86073 9.18593 1.53906 10.8031 1.53906 12.4362C1.53906 14.0694 1.86074 15.6865 2.48572 17.1954C3.11069 18.7042 4.02674 20.0752 5.18155 21.23L13.9753 12.4362L22.769 3.64249Z",
  fill: "#1C53E7"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M45.312 18.9069C45.312 17.2266 44.3899 15.9151 42.8121 15.3823C44.226 14.911 45.0866 13.6201 45.0866 12.1037C45.0866 9.68569 43.2834 8.29226 40.8654 8.29226H35.4966V22.8822H41.0293C43.6112 22.8822 45.312 21.5093 45.312 18.9069ZM43.9801 12.1037C43.9801 14.1119 42.5047 14.9315 40.7424 14.9315H36.6031V9.27586H40.7424C42.5047 9.27586 43.9801 10.0955 43.9801 12.1037ZM44.2055 18.9069C44.2055 20.7716 42.894 21.8986 40.9063 21.8986H36.6031V15.9151H40.9063C42.894 15.9151 44.2055 17.0421 44.2055 18.9069Z",
  fill: "black"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M56.4573 22.8822V13.0053H55.4123V19.1323C55.4123 20.997 54.3877 22.0831 52.6254 22.0831C50.8632 22.0831 49.9001 21.038 49.9001 19.1323V13.0053H48.855V19.3167C48.855 20.4847 49.2238 21.4273 49.8796 22.0626C50.5148 22.6773 51.3959 23.0052 52.5025 23.0052C53.691 23.0052 54.6746 22.5749 55.4123 21.7142V22.8822H56.4573Z",
  fill: "black"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.5924 9.58323V8.29226H60.3014V9.58323H61.5924ZM61.4694 22.8822V13.0053H60.4244V22.8822H61.4694Z",
  fill: "black"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68.6849 22.8822V21.9601H67.9677C66.7997 21.9601 66.4513 21.4068 66.4513 20.3003V8.29226H65.4062V20.3208C65.4062 21.8577 66.1849 22.8822 67.7832 22.8822H68.6849Z",
  fill: "black"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M74.8551 22.8822V21.9601H74.1379C73.0928 21.9601 72.6215 21.3454 72.6215 20.3208V13.784H74.8551V13.0053H72.6215V9.84962H71.5764V13.0053H70.224V13.784H71.5764V20.3003C71.5764 21.7962 72.3961 22.8822 73.9534 22.8822H74.8551Z",
  fill: "black"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M90.5942 17.9438C90.5942 16.5299 90.4097 15.0135 89.3647 13.9684C88.668 13.2717 87.7253 12.8824 86.6188 12.8824C85.5123 12.8824 84.5697 13.2717 83.8729 13.9684C82.8279 15.0135 82.6434 16.5299 82.6434 17.9438C82.6434 19.3577 82.8279 20.8741 83.8729 21.9191C84.5697 22.6158 85.5123 23.0052 86.6188 23.0052C87.7253 23.0052 88.668 22.6158 89.3647 21.9191C90.4097 20.8741 90.5942 19.3577 90.5942 17.9438ZM89.5491 17.9438C89.5491 19.0913 89.4876 20.4233 88.668 21.2429C88.1352 21.7757 87.418 22.0831 86.6188 22.0831C85.8196 22.0831 85.1024 21.7757 84.5697 21.2429C83.75 20.4233 83.6885 19.0913 83.6885 17.9438C83.6885 16.7963 83.75 15.4643 84.5697 14.6446C85.1024 14.1119 85.8196 13.8045 86.6188 13.8045C87.418 13.8045 88.1352 14.1119 88.668 14.6446C89.4876 15.4643 89.5491 16.7963 89.5491 17.9438Z",
  fill: "black"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M101.606 22.8822V16.5708C101.606 15.4028 101.237 14.4602 100.581 13.825C99.9458 13.2102 99.0647 12.8824 97.9581 12.8824C96.7696 12.8824 95.786 13.3127 95.0484 14.1733V13.0053H94.0033V22.8822H95.0484V16.7553C95.0484 14.8905 96.0729 13.8045 97.8352 13.8045C99.5975 13.8045 100.561 14.8496 100.561 16.7553V22.8822H101.606Z",
  fill: "black"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M119.835 18.4151C119.835 17.0626 119.528 15.9766 118.749 15.2184C118.134 14.6037 117.192 14.1938 115.88 14.0094L114.118 13.7635C113.606 13.702 113.298 13.5176 113.114 13.3332C112.889 13.1078 112.827 12.8414 112.827 12.657C112.827 12.0217 113.339 11.3045 114.589 11.3045C115.225 11.3045 116.434 11.243 117.356 12.1652L119.61 9.91109C118.36 8.66111 116.782 8.16931 114.692 8.16931C111.372 8.16931 109.364 10.116 109.364 12.7799C109.364 14.0299 109.692 15.0135 110.368 15.7102C111.024 16.3864 112.007 16.8167 113.298 17.0012L115.061 17.2471C115.532 17.3085 115.839 17.452 116.024 17.6364C116.229 17.8618 116.311 18.1487 116.311 18.497C116.311 19.3372 115.635 19.8085 114.221 19.8085C113.053 19.8085 111.721 19.5421 110.962 18.7839L108.667 21.079C110.143 22.5954 111.967 23.0052 114.2 23.0052C117.274 23.0052 119.835 21.3864 119.835 18.4151Z",
  fill: "black"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M133.007 17.7594V8.29226H129.421V17.6774C129.421 19.0298 128.642 19.8085 127.453 19.8085C126.265 19.8085 125.527 19.0298 125.527 17.6774V8.29226H121.941V17.7594C121.941 20.956 124.421 23.0052 127.453 23.0052C130.486 23.0052 133.007 20.956 133.007 17.7594Z",
  fill: "black"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M142.887 12.9848C142.887 13.743 142.313 14.4602 141.329 14.4602H139.301V11.5094H141.329C142.313 11.5094 142.887 12.2266 142.887 12.9848ZM147.252 22.8822L144.096 16.7963C145.243 16.2225 146.473 14.9725 146.473 12.9848C146.473 10.5873 144.731 8.29226 141.493 8.29226H135.715V22.8822H139.301V17.452H140.51L143.092 22.8822H147.252Z",
  fill: "black"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M159 22.8822V19.6856H152.668V17.1241H158.078V13.9274H152.668V11.4889H159V8.29226H149.082V22.8822H159Z",
  fill: "black"
});

var _ref15 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "sureLogoGradient",
  x1: 12.1101,
  y1: 10.5707,
  x2: 19.4152,
  y2: 27.4149,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", null), React.createElement("stop", {
  offset: 0.0220404,
  stopColor: "#020611"
}), React.createElement("stop", {
  offset: 0.1025,
  stopColor: "#0A1B49"
}), React.createElement("stop", {
  offset: 0.1833,
  stopColor: "#102D79"
}), React.createElement("stop", {
  offset: 0.2628,
  stopColor: "#163BA1"
}), React.createElement("stop", {
  offset: 0.3406,
  stopColor: "#1A46BF"
}), React.createElement("stop", {
  offset: 0.4164,
  stopColor: "#1D4FD5"
}), React.createElement("stop", {
  offset: 0.4892,
  stopColor: "#1E53E3"
}), React.createElement("stop", {
  offset: 0.5555,
  stopColor: "#1F55E7"
})));

var SvgLogoSureBuiltOnSure = function SvgLogoSureBuiltOnSure(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 159,
    height: 31,
    viewBox: "0 0 159 31",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoSureBuiltOnSure, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-sure-built-on-sure.2df5cbe6.svg";
export { ForwardRef as ReactComponent };